// src/components/dashboard/Dashboard.js

import React, { useState, useEffect } from 'react';
import './Dashboard.css';
import nftData from '../../nftData';

const Dashboard = ({ account }) => {
  const [nfts, setNfts] = useState([]);

  useEffect(() => {
    if (account) {
      fetchNfts(account);
    }
  }, [account]);

  const fetchNfts = async (account) => {
    // 여기에 실제 API 호출 코드 추가 가능
    const userNfts = nftData.filter(nft => nft.sandbox.creator.toLowerCase() === account.toLowerCase());
    setNfts(userNfts);
  };

  return (
    <div className="dashboard">
      <h1>My Dashboard</h1>
      <div className="nft-list">
        {nfts.map(nft => (
          <div key={nft.id} className="nft-card">
            <img src={nft.image} alt={nft.name} />
            <h2>{nft.name}</h2>
            <p>{nft.description}</p>
            <a href={nft.external_url} target="_blank" rel="noopener noreferrer">View on Sandbox</a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
